import { useHistory } from "react-router-dom";
import { Col, Form, Input, Row, Spin, notification } from "antd";

import { withProcedureWraper } from "../../../..";
import { Box, ButtonList, Icon } from "../../../../../../components";
import { RegExp } from "../../../../../../constants";
import { useBCRequest, useBCSteps, useBCUpdate } from "../../hooks";
import { StringHelper } from "../../../../../../helper";
import {
  IBusinessCard,
  IBusinessCardResponse,
} from "../../models/IBusinessCard";
import { useQueryClient } from "@tanstack/react-query";
import { Routes } from "../../../../../../AppRoutes";
import BoxSectionItem from "../../../../../../components/box-section/box-section-item";

type IBusinessCardForm = Omit<IBusinessCard, "id" | "eApprovalProcess">;

const fallback = {} as IBusinessCardResponse;

const BCEdit = withProcedureWraper(() => {
  const queryClient = useQueryClient();
  const history = useHistory();

  const { data: request = fallback, isLoading: isRequestLoading } =
    useBCRequest();
  const { mutate, isLoading: isUpdateLoading } = useBCUpdate();
  const { approve } = useBCSteps();
  const { canEdit } = approve(request?.eApprovalProcess);

  const handleFinish = (values: IBusinessCardForm) => {
    mutate(
      { id: request.id!, body: values },
      {
        onSuccess(response: any) {
          queryClient.invalidateQueries({ queryKey: ["BC-requests"] });
          history.push(`${Routes.businessCard.path}/${response.id}`);
          notification.success({
            message: "Thành công!",
            description: `Chỉnh sửa yêu cầu thành công.`,
          });
        },
        onError() {
          notification.error({
            message: "Thất bại",
            description: `Chỉnh sửa yêu cầu thất bại.`,
          });
        },
      }
    );
  };

  if (isRequestLoading)
    return (
      <div className="flex-center">
        <Spin />
      </div>
    );

  return (
    <Spin spinning={isUpdateLoading}>
      <Form
        size="large"
        layout="vertical"
        onFinish={handleFinish}
        initialValues={request}
      >
        <div className="pd15">
          <div className="PageHead flex-center">
            <div className="title" style={{ margin: 0 }}>
              <div className="btnBack" onClick={() => history.goBack()}>
                <Icon.ArrowLeft />
              </div>
              Chỉnh sửa phiếu đề nghị in danh thiếp
            </div>
          </div>
          <Box title="Thông tin">
            <Row gutter={[32, 0]}>
              <Col span={24}>
                <Form.Item
                  label="Họ tên"
                  name="eName"
                  rules={[
                    { required: true, message: "Vui lòng nhập trường này!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <BoxSectionItem
                  textLeft="Cơ quan/Đơn vị"
                  textRight={
                    StringHelper.verticalBarSplit<string[]>(
                      request.eDepartment
                    )[1]
                  }
                />
              </Col>
              <Col span={12}>
                <BoxSectionItem
                  textLeft="Đơn vị"
                  textRight={
                    StringHelper.verticalBarSplit<string[]>(request.eUnit)[1]
                  }
                />
              </Col>
            </Row>
          </Box>
          <Box title="Thông tin in danh thiếp">
            <Row gutter={[32, 0]}>
              <Col span={8}>
                <Form.Item
                  label="Họ và tên"
                  name="eCardName"
                  rules={[
                    { required: true, message: "Vui lòng nhập trường này!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Chức danh"
                  name="eCardTitle"
                  rules={[
                    { required: true, message: "Vui lòng nhập trường này!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Email"
                  name="eCardEmail"
                  rules={[
                    { required: true, message: "Vui lòng nhập trường này!" },
                    {
                      pattern: RegExp.viagsEmail,
                      message: "Định dạng email không đúng!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Địa chỉ"
                  name="eCardAddress"
                  rules={[
                    { required: true, message: "Vui lòng nhập trường này!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Địa chỉ website"
                  name="eCardSite"
                  rules={[
                    { required: true, message: "Vui lòng nhập trường này!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Số điện thoại"
                  name="eCardPhone"
                  rules={[
                    { required: true, message: "Vui lòng nhập trường này!" },
                    {
                      pattern: RegExp.vnPhoneNumber,
                      message: "Định dạng số điện thoại không đúng!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Ghi chú" name="eDescription">
                  <Input.TextArea />
                </Form.Item>
              </Col>
            </Row>
          </Box>
          <div className="flex-end">
            <ButtonList
              items={[
                {
                  buttonType: "danger",
                  hidden: !canEdit,
                  label: "Huỷ",
                  onClick: () => history.goBack(),
                },
                {
                  buttonType: "warning",
                  hidden: !canEdit,
                  label: "Xác nhận",
                  type: "submit",
                },
              ]}
            />
          </div>
        </div>
      </Form>
    </Spin>
  );
});

export default BCEdit;
